
import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import { Logger } from "@/utils/Logger";
import { iPService } from "@/core/service/licencesnationales/IPService";
import { Message, MessageType } from "@/core/CommonDefinition";
import ConfirmPopup from "@/components/common/ConfirmPopup.vue";
import { LicencesNationalesBadRequestApiError } from "@/core/service/licencesnationales/exception/LicencesNationalesBadRequestApiError";
import { AxiosResponse } from "axios";
import { rulesForms } from "@/core/RulesForm";
import InfosIPs from "@/components/ip/InfosIPs.vue";

const ListeAccesProps = Vue.extend({
  props: {
    sirenEtabSiAdmin: {
      type: String,
      default: ""
    }
  }
});

@Component({
  components: { InfosIPs, ConfirmPopup }
})
export default class ListeAcces extends ListeAccesProps {
  public metaInfo(): any {
    return {
      meta: [
        {
          name: "description",
          content: "Liste des IPs de l'application des Licences Nationales"
        }
      ],
      title: "Mes IPs - Licences Nationales"
    };
  }

  rulesForm: any = rulesForms;
  refreshKey: number = 0;
  statut: string = "";
  type: string = "";
  selectStatut: Array<string> = [
    "En attente d'attestation",
    "IP Validée par l'Abes",
    "En attente d'examen par l'Abes",
    "Tous"
  ];
  selectType: Array<string> = [
    "IPV4",
    "IPV6",
    "Plage IPV4",
    "Plage IPV6",
    "Tous"
  ];
  rechercher: string = "";
  acces: Array<any> = [];
  title: string = "";
  id: string = "";
  whoIs: string = "";
  whoIs2: string = "";
  currentIP: any = "";
  bufferActions: Array<any> = [];
  error: string = "";
  dialog: boolean = false;
  isExportLoading: boolean = false;
  buttlonLoading: boolean = false;
  notification: string = "";
  commentaires: string = "";
  headers = [{}];
  dataLoading: boolean = true;

  infobulleAttente: string =
    "IP transmise aux éditeurs et à l'Inist si validée par l'Abes";
  infobulleAttestation: string =
    "IP transmise aux éditeurs et à l'Inist après réception de l'attestation";
  infobulleValid: string =
    "IP transmise aux éditeurs et à l’Inist à chaque fin de mois";

  get getUserSiren() {
    return this.$store.state.user.siren;
  }

  get currentEtabNom() {
    return this.$store.getters.getCurrentEtablissement().nom;
  }

  get isAdmin() {
    return this.$store.getters.isAdmin();
  }

  get filteredAccesByStatut(): string[] {
    const conditions = [] as any;
    if (this.statut) {
      conditions.push(this.filterStatut);
    }
    if (conditions.length > 0) {
      return this.filteredAccesByType.filter(acces => {
        return conditions.every(condition => {
          return condition(acces);
        });
      });
    }
    return this.filteredAccesByType;
  }

  get filteredAccesByType(): string[] {
    const conditions = [] as any;
    if (this.type) {
      conditions.push(this.filterType);
    }
    if (conditions.length > 0) {
      return this.acces.filter(acces => {
        return conditions.every(condition => {
          return condition(acces);
        });
      });
    }
    return this.acces;
  }

  mounted() {
    moment.locale("fr");
    this.collecterAcces();
    this.id = this.getIdAcces(this.acces);
    this.setHeaders();
  }

  setHeaders() {
    if (this.isAdmin) {
      this.headers = [
        {
          text: "Date de saisie",
          align: "start",
          value: "dateCreation",
          sortable: true,
          width: "9%"
        },
        {
          text: "Type d'IP",
          value: "typeIp",
          sortable: true,
          width: "9%"
        },
        { text: "Valeur", value: "ip", sortable: true, width: "20%" },
        { text: "Statut", value: "statut", sortable: true, width: "13%" },
        { text: "Action", value: "buffer", sortable: false, width: "13%" },
        {
          text: "Dernière action de l’Abes",
          value: "dateModification",
          sortable: true,
          width: "10%"
        },
        {
          text: "Précision sur l’IP",
          value: "commentaires",
          sortable: true,
          width: "17%"
        },
        { text: "Examiner", value: "action", sortable: false, width: "9%" }
      ];
    } else {
      this.headers = [
        {
          text: "Date de saisie",
          align: "start",
          value: "dateCreation",
          sortable: true,
          width: "9%"
        },
        {
          text: "Type d'IP",
          value: "typeIp",
          sortable: true,
          width: "20%"
        },
        { text: "Valeur", value: "ip", sortable: true, width: "15%" },
        { text: "Statut", value: "statut", sortable: true, width: "15%" },
        {
          text: "Dernière action de l’Abes",
          value: "dateModification",
          sortable: true,
          width: "15%"
        },
        {
          text: "Précision sur l’IP",
          value: "commentaires",
          sortable: true,
          width: "17%"
        },
        { text: "Supprimer", value: "action", sortable: false, width: "10%" }
      ];
    }
  }

  getIdAcces(acces): any {
    return {
      id: acces.id
    };
  }

  filterStatut(statutRecherche) {
    return statutRecherche.statut.toString().includes(this.statut);
  }

  filterType(typeRecherche) {
    return typeRecherche.typeIp.toString() === this.type;
  }

  getAll() {
    if (this.isAdmin)
      return iPService.getListIPEtab(
        this.$store.getters.getToken(),
        this.$store.getters.getCurrentEtablissement().siren
      );
    else
      return iPService.getListIP(
        this.$store.getters.getToken(),
        this.getUserSiren
      );
  }

  collecterAcces(): void {
    this.getAll()
      .then(response => {
        this.acces = response.data.map(this.affichageAcces);
      })
      .catch(err => {
        Logger.error(err);
        this.error = err.response.data.message;
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  affichageAcces(acces) {
    let typeAcces = "";
    if (acces.typeAcces === "range") typeAcces = "Plage ";
    return {
      id: acces.id,
      dateCreation: moment(acces.dateCreation).format("L"),
      dateModification: this.getDateModification(acces),
      typeIp: typeAcces + acces.typeIp,
      typeAcces: acces.typeAcces,
      ip: acces.ip,
      statut: acces.statut,
      commentaires: acces.commentaires
    };
  }

  getDateModification(acces) {
    if (acces.dateModification === null) return acces.dateModification;
    else return moment(acces.dateModification).format("L");
  }

  openDialog(item): void {
    this.clearAlerts();
    this.fetchwhoIs(item);
    this.dialog = true;
    this.currentIP = item;
  }

  fetchwhoIs(item): void {
    this.whoIs = "";
    this.whoIs2 = "";

    if (item.typeAcces === "ip") {
      iPService
        .getWhoIs(this.$store.getters.getToken(), item.ip)
        .then(res => {
          this.whoIs = res.data;
        })
        .catch(() => {
          Logger.error("Impossible d'exécuter le WhoIS");
        });
    } else {
      const ips = this.splitRangeIntoIPs(item.typeIp, item.ip);
      iPService
        .getWhoIs(this.$store.getters.getToken(), ips[0])
        .then(res => {
          this.whoIs = res.data;
        })
        .catch(() => {
          Logger.error("Impossible d'exécuter le WhoIS");
        });
      iPService
        .getWhoIs(this.$store.getters.getToken(), ips[1])
        .then(res => {
          this.whoIs2 = res.data;
        })
        .catch(() => {
          Logger.error("Impossible d'exécuter le WhoIS");
        });
    }
  }

  splitRangeIntoIPs(typeIP: string, range: string): string[] {
    let ip1 = "";
    let ip2 = "";

    if (typeIP === "Plage IPV4") {
      range.split(".").forEach(element => {
        if (element.includes("-")) {
          const tabSplit = element.split("-");
          ip1 += "." + tabSplit[0];
          ip2 += "." + tabSplit[1];
        } else {
          ip1 += "." + element;
          ip2 += "." + element;
        }
      });
    } else {
      range.split(":").forEach(element => {
        if (element.includes("-")) {
          const tabSplit = element.split("-");
          ip1 += ":" + tabSplit[0];
          ip2 += ":" + tabSplit[1];
        } else {
          ip1 += ":" + element;
          ip2 += ":" + element;
        }
      });
    }

    ip1 = ip1.substring(1);
    ip2 = ip2.substring(1);
    return [ip1, ip2];
  }

  checkIfWhoIsRenater(whoIs: string): boolean {
    if (whoIs.toLowerCase().includes("renater")) {
      return true;
    }
    return false;
  }

  highlightRenater(whoIs: string) {
    return whoIs
      .replaceAll("renater", "<mark>renater</mark>")
      .replaceAll("RENATER", "<mark>RENATER</mark>");
  }

  dispatchAllAction(): void {
    this.updateIP()
      .then(() => {
        this.notification = "Actions effectuées";
      })
      .catch(err => {
        Logger.debug(err);
        this.error = err.response.data.message;
      })
      .finally(() => {
        this.collecterAcces();
        this.clearActions();
        this.buttlonLoading = false;
      });
  }

  updateIP(): Promise<AxiosResponse> {
    this.buttlonLoading = true;
    return iPService.updateIP(
      this.$store.getters.getToken(),
      this.$store.getters.getCurrentEtablissement().siren,
      this.bufferActions
    );
  }

  addActionToBuffer(action: string): void {
    this.bufferActions.push({
      idIp: this.currentIP.id,
      action: action,
      ip: this.currentIP.ip,
      commentaire: this.commentaires
    });
    this.addActionToDatatable(action, this.currentIP.id);
    this.commentaires = "";
    this.dialog = false;
    this.refreshKey++;
  }

  addActionToDatatable(action: string, id: number) {
    this.acces.forEach(element => {
      if (element.id === id) {
        element.buffer = action;
      }
    });
  }

  // Suppression par un USER
  async supprimerIP(IDip: string, ip: string) {
    const confirmed = await (this.$refs.confirm as ConfirmPopup).open(
      `Vous êtes sur le point de supprimer définitivement l'adresse IP ou plage d'adresses IP ${ip}

                Etes-vous sûr de vouloir effectuer cette action ?`
    );
    if (confirmed) {
      this.buttlonLoading = true;
      this.clearAlerts();

      iPService
        .deleteIP(this.$store.getters.getToken(), IDip)
        .then(() => {
          this.notification = "IP supprimée.";
        })
        .catch(err => {
          Logger.error = err;
          this.error = err.message;
        })
        .finally(() => {
          this.buttlonLoading = false;
          this.collecterAcces();
        });
    }
  }

  RowClasses(item) {
    let action = "";
    this.bufferActions.forEach(element => {
      if (element.ip === item.ip) {
        action = element.action;
      }
    });
    return action;
  }

  clearActions() {
    this.bufferActions = [];
    this.refreshKey++;
    this.acces.forEach(element => {
      if (element.buffer !== undefined) {
        delete element.buffer;
      }
    });
  }

  clearAlerts() {
    this.notification = "";
    this.error = "";
  }

  getSirenEtabSujet() {
    if (this.isAdmin)
      return this.$store.getters.getCurrentEtablissement().siren;
    else return this.getUserSiren;
  }

  downloadIPs(): void {
    this.isExportLoading = true;
    this.$store.dispatch("closeDisplayedMessage");
    iPService
      .downloadIPs(this.getSirenEtabSujet(), this.$store.state.user.token)
      .then(response => {
        const fileURL = window.URL.createObjectURL(
          new Blob([response.data], { type: "application/csv" })
        );
        const fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", "export.csv");
        document.body.appendChild(fileLink);

        fileLink.click();
        this.isExportLoading = false;
      })
      .catch(err => {
        Logger.error(err.toString());
        const message: Message = new Message();
        message.type = MessageType.ERREUR;
        if (err instanceof LicencesNationalesBadRequestApiError) {
          message.texte = err.message;
        } else {
          message.texte = "Impossible d'exécuter l'action : " + err.message;
        }
        message.isSticky = true;

        this.$store.dispatch("openDisplayedMessage", message).catch(err => {
          Logger.error(err.toString());
        });
        this.isExportLoading = false;
      });
  }

  revenirInfosEtab(): void {
    this.$router.push({ name: "AfficherEtablissement" }).catch(err => {
      Logger.error(err);
    });
  }

  eventStatutChoice(element: string): void {
    if (element === "Tous") {
      this.statut = "";
    } else {
      this.statut = element;
    }
    this.filteredAccesByStatut;
  }

  eventTypeChoice(element: string): void {
    if (element === "Tous") {
      this.type = "";
    } else {
      this.type = element;
    }
    this.filteredAccesByType;
  }
}
